export default __webpack_public_path__ + "imgs/battery-small-80.png";